import { render } from "./NewAcceptTermLogin.vue?vue&type=template&id=26fae4fe"
import script from "./NewAcceptTermLogin.vue?vue&type=script&lang=js"
export * from "./NewAcceptTermLogin.vue?vue&type=script&lang=js"

import "./NewAcceptTermLogin.vue?vue&type=style&index=0&id=26fae4fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__